import React from "react";
import { MainHeader } from "../components/global/MainHeader";
import { Socials } from "../components/Home/Socials";
import { ShopViewComponent } from "../components/Shop/ShopViewComponent";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { MediaCard } from "../components/global/MediaCard";
import { productData } from "../data/carousel";
import { getAllDocuments } from "../firebase/firebaseCrud";
import { useCart } from "../context/cart-context";

export const ShopView = () => {
  const { isLoading, setIsLoading } = useCart();

  const [products, setProducts] = React.useState("");

  const getProducts = async () => {
    const prods = await getAllDocuments("product-list");
    setProducts(prods);
  };

  React.useEffect(() => {
    getProducts();
  }, []);

  React.useEffect(() => {
    if (products.length <= 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [products]);

  const [noOfElement, setnoOfElement] = React.useState(4);
  const slice = products.slice(0, noOfElement);

  return (
    <React.Fragment>
      <MainHeader name={"View Product"} />
      <ShopViewComponent />

      {/* <Box className="mx-auto place-items-center place-content-center flex">
        <Divider className=" py-6 w-[80%]" />
      </Box>
      <Box className="mx-auto pt-10 bg-white px-20 py-4">
        <Typography
          variant="h3"
          // fontWeight={900}
          fontSize={{ xs: "20px", sm: "25px", md: "30px" }}
          lineHeight={{ xs: "103%", sm: "105.5%" }}
          letterSpacing={"0.1rem"}
          color="primary"
          className=" pb-3 text-center"
        >
          Products You Might like
        </Typography>
        <Grid container spacing={2}>
          {slice &&
            slice.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} lg={3} key={item.id}>
                <MediaCard
                  key={index}
                  imgSrc={item.imgSrc}
                  title={item.name}
                  path={`/shop/view/${item.slug}/${item.id}`}
                  price={`£ ${item.price}`}
                  priceColor={"primary"}
                />
              </Grid>
            ))}
        </Grid>
      </Box> */}
      <Socials imgSrc={"../../../../SBD/StrandsHairs.png"} />
    </React.Fragment>
  );
};
